import { ArrowLeft, ArrowUpRight, Phone } from 'lucide-react'
import { site } from '../content/site'
import type { Article } from '../types'

interface ArticlePageProps {
  article: Article
}

function formatDate(value: string) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'America/Los_Angeles',
  }).format(new Date(value))
}

export function ArticlePage({ article }: ArticlePageProps) {
  return (
    <article className="article-page">
      <header className="article-hero">
        <div className="shell article-hero__grid">
          <div>
            <a className="back-link" href="/insights/"><ArrowLeft aria-hidden="true" /> All insights</a>
            <p className="eyebrow eyebrow--light">{article.eyebrow}</p>
            <h1>{article.title}</h1>
            <p>{article.description}</p>
            <div className="article-hero__meta">
              <span>By {site.founder}</span>
              <time dateTime={article.modified}>Updated {formatDate(article.modified)}</time>
              <span>{article.readTime}</span>
            </div>
          </div>
          <img src={article.image} alt={article.imageAlt} />
        </div>
      </header>
      <div className="shell article-body-grid">
        <div className="article-body">
          {article.sections.map((section, index) => (
            <section key={section.heading ?? index}>
              {section.heading ? <h2>{section.heading}</h2> : null}
              {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.list ? <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul> : null}
              {section.externalLink ? (
                <a className="source-link" href={section.externalLink.href} target="_blank" rel="noreferrer">
                  {section.externalLink.label} <ArrowUpRight aria-hidden="true" />
                </a>
              ) : null}
            </section>
          ))}
        </div>
        <aside className="article-cta">
          <p className="eyebrow">Need help with your system?</p>
          <h2>Start with a few details.</h2>
          <p>Send photos and a description, or call if the situation is urgent.</p>
          <a className="button button--accent" href="/contact/">Request service <ArrowUpRight aria-hidden="true" /></a>
          <a className="text-link" href={site.phoneHref}><Phone aria-hidden="true" /> {site.phoneDisplay}</a>
        </aside>
      </div>
    </article>
  )
}
